// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__cdFzC"};